"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const video_client_core_1 = require("@video/video-client-core");
const styles_1 = require("./styles");
const styling_1 = require("../../../styling");
const CarouselSlideWrapper = (0, mobx_react_lite_1.observer)(({ onClick, onKeydown, children, classes }) => {
    const mergedClasses = (0, styling_1.useStyles)({ target: classes !== null && classes !== void 0 ? classes : {}, source: styles_1.carouselSlideWrapperStyles }, "carousel-slide-wrapper");
    return (react_1.default.createElement("div", { 
        // className={shouldDisplayPosterImage ? mergedClasses.root : mergedClasses.disconnectedWrapper}
        className: mergedClasses.root, onClick: onClick, onKeyDown: onKeydown, tabIndex: 0, role: "button", style: { cursor: video_client_core_1.adapter.device.isMobileDevice ? "pointer" : "default" } }, children));
});
exports.default = CarouselSlideWrapper;
//# sourceMappingURL=index.js.map